import { ModuleStepType } from '@smw/common-rest-dtos';

export type AnalyticsEvent =
  | PageOpened
  | PageClosed
  | SignedUp
  | SignedIn
  | PasswordLost
  | DocumentDownloaded
  | MotivationDone
  | CheckUpDone
  | TestCompleted
  | ConversationCreated
  | ConversationOpened
  | ConversationStepDone
  | ChatbotMessageSent
  | HRDashboardOpened
  | TrainingStepCompleted
  | TrainingStatusChange
  | ObjectiveAdded
  | ConversationStatusChange
  | TrainingsStepDone
  | TrainingsStatusChange
  | TrainerQuestion
  | AccountActivated
  | ConversationCreated
  | ObjectiveDone
  | ObjectiveEdited
  | ConversationStatusChange;

// todo: unsure what this is used for, refactor
export type EventId = AnalyticsEvent['id'];

export enum EventIdentifier {
  PageOpened = 'pageOpened',
  PageClosed = 'pageClosed',
  PasswordLost = 'passwordLost',
  DocumentDownloaded = 'documentDownloaded',
  TestCompleted = 'testCompleted',
  MotivationDone = 'motivationDone',
  CheckUpDone = 'checkUpDone',
  UserSignedUp = 'userSignedUp',
  UserSignedIn = 'userSignedIn',
  ConversationCreated = 'conversationCreated',
  ConversationOpened = 'conversationOpened',
  ConversationStepDone = 'conversationStepDone',
  ConversationStatusChange = 'conversationStatusChange',
  ChatbotMessageSent = 'chatbotMessageSent',
  HRDashboardOpened = 'hrDashboardOpened',
  TrainingsStepCompleted = 'trainingStepCompleted',
  TrainingsStatusChange = 'trainingStatusChange',
  TrainerQuestion = 'trainerQuestion',
  TrainingsStepDone = 'trainingsStepDone',
  ObjectiveAdded = 'objectiveAdded',
  ObjectiveDone = 'objectiveDone',
  objectiveEdited = 'objectiveEdited',
  AccountActivated = 'accountActivated',
}

export type PageOpened = {
  id: EventIdentifier.PageOpened;
  data: {
    url: string;
    previousUrl: string;
  };
};

export type PageClosed = {
  id: EventIdentifier.PageClosed;
  data: {
    url: string;
  };
};

type PasswordLost = {
  id: EventIdentifier.PasswordLost;
  data: {
    email: string;
  };
};

type DocumentDownloaded = {
  id: EventIdentifier.DocumentDownloaded;
  data: {
    page: string;
    documentName: string;
  };
};

type TestCompleted = {
  id: EventIdentifier.TestCompleted;
  data?: void;
};

type MotivationDone = {
  id: EventIdentifier.MotivationDone;
  data?: void;
};

type CheckUpDone = {
  id: EventIdentifier.CheckUpDone;
  data?: void;
};

type SignedUp = {
  id: EventIdentifier.UserSignedUp;
  data?: void;
};

type SignedIn = {
  id: EventIdentifier.UserSignedIn;
  data?: void;
};

type ConversationCreated = {
  id: EventIdentifier.ConversationCreated;
  data: {
    conversationType: string;
    recurrence: string;
  };
};

type ConversationOpened = {
  id: EventIdentifier.ConversationOpened;
  data: {
    conversationType: string;
    recurrenceInterval: string;
    recurrenceFrequency: string;
  };
};

type ConversationStepDone = {
  id: EventIdentifier.ConversationStepDone;
  data: {
    conversationId: string;
    stepName: string;
  };
};

type ChatbotMessageSent = {
  id: EventIdentifier.ChatbotMessageSent;
  data: {
    assistantName: string;
  };
};

type HRDashboardOpened = {
  id: EventIdentifier.HRDashboardOpened;
  data?: void;
};

type TrainingStepCompleted = {
  id: EventIdentifier.TrainingsStepCompleted;
  data: {
    trainingStepName: string;
    trainingStatusName: string;
    eventId?: string;
    stepType: ModuleStepType;
  };
};

type TrainingStatusChange = {
  id: EventIdentifier.TrainingsStatusChange;
  data: {
    TrainingStatusName: string;
  };
};

type ObjectiveAdded = {
  id: EventIdentifier.ObjectiveAdded;
  data?: void;
};

type ConversationStatusChange = {
  id: EventIdentifier.ConversationStatusChange;
  data: {
    conversationId: string;
    conversationStatusName: string;
    conversationType: string;
  };
};

type TrainingsStepDone = {
  id: EventIdentifier.TrainingsStepDone;
  data: {
    trainingsStepName: string;
    trainingsStatusName: string;
  };
};

type TrainingsStatusChange = {
  id: EventIdentifier.TrainingsStatusChange;
  data: {
    trainingsStepName: string;
    trainingsStatusName: string;
  };
};

type TrainerQuestion = {
  id: EventIdentifier.TrainerQuestion;
  data: {
    trainingsDate: string;
  };
};

type AccountActivated = {
  id: EventIdentifier.AccountActivated;
  data?: void;
};

type ObjectiveDone = {
  id: EventIdentifier.ObjectiveDone;
  data: {
    objectiveId: string;
  };
};

type ObjectiveEdited = {
  id: EventIdentifier.objectiveEdited;
  data: {
    objectiveId: string;
    objectivePropertyName: string;
  };
};
